import data from "../data";
import Columns from "./tableColumns";
import { Spin, Table, Modal } from "antd";
import { usePaginationBezPrzekazania } from "../../../context/PaginationContextBezPrzekazania";
import ExpandedRowRender from "./expanderRender";
import { useNavigate } from "react-router-dom";
import SearchInput from "./search";
import NowyWpisButton from "./newWplyw";
import { useEffect, useState } from "react";
import { SocketContext } from "../../../context/socketContext";
import { useContext } from "react";
import { useBlockedRows } from "../../../context/BlockedRowsContext";
import datetimeParser from "../../../components/datetimeParser";
import {Button, Flex} from "antd";
import axios from '../../../context/axiosConfig'
import FastFilters from "./fastFilters";

const WplywyTable = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const { pagination, setPagination } = usePaginationBezPrzekazania();
    const navigate = useNavigate();
    const socket = useContext(SocketContext);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const blockedRows = useBlockedRows().blockedRows

    const handleRowClick = (record) => {
        if (blockedRows.some(item => item.msr_wplywy_msr_wplywy_id == record.msr_wplywy_id)) {
            setSelectedRow(record);
            setIsModalOpen(true);
        } else {
            navigate(`/wplywy/${record.msr_wplywy_id}`);
        }
    };

    const unBlockWplyw = async (wplywid) => {
        try {
          // Show loading indicator if needed (optional)
      
          // Send the request to unblock the wplyw
          const response = await axios.post("/wplyw/unblock/live", { wplywid });
      
          // Check if the response indicates success
          if (response?.data?.status) {
            navigate(`/wplywy/${wplywid}`);
          } else {
            alert('Failed to unblock the wplyw. Please try again.');
          }
        } catch (error) {
          console.error('Error unblocking wplyw:', error);
          alert('An error occurred while unblocking the wplyw.');
        } finally {
          // Hide loading indicator if needed (optional)
        }
      };

    const handleTableChange = (paginationInfo) => {
        const { current, pageSize } = paginationInfo;
        setPagination((prev) => ({
            ...prev,
            current, 
            pagesize: pageSize, 
        }));
    };

    const onExpand = (expanded, record) => {
        setExpandedRowKeys((prevExpandedRowKeys) => {
            if (expanded) {
                return [...prevExpandedRowKeys, record.msr_wplywy_id];
            } else {
                return prevExpandedRowKeys.filter((key) => key !== record.msr_wplywy_id);
            }
        });
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedRow(null);
    };

    const rows = data();
    return (
        <>
            <div
                className="table-header"
                style={{
                    display: "flex",
                    gap: "10px",
                    marginBottom: "16px",
                    padding: "20px",
                    paddingBottom: "0",
                }}
            >
                <NowyWpisButton />
                <SearchInput />
            </div>
            <div
                className="advanced-fast-search"
                style={{
                    display: "flex",
                    gap: "10px",
                    marginBottom: "16px",
                    padding: "20px",
                    paddingBottom: "0",
                    paddingTop: '0',
                }}
            >
            </div>
            <div className="table-body" style={{ padding: "20px", paddingTop: "0" }}>
                <Spin spinning={pagination.loading}>
                    <Table
                        columns={Columns()}
                        dataSource={rows.data}
                        loading={pagination.loading}
                        expandable={{
                            expandedRowRender: ExpandedRowRender,
                            rowExpandable: (record) => record.persons && record.persons.length > 1,
                        }}
                        expandedRowKeys={expandedRowKeys}
                        onExpand={onExpand}
                        pagination={{
                            current: pagination.current,
                            pageSize: pagination.pagesize,
                            total: rows.total, 
                            showSizeChanger: true, 
                            pageSizeOptions: ["1", "10", "20", "50", "100"],
                        }}
                        onRow={(record) => ({
                            onClick: () => handleRowClick(record),
                        })}
                        onChange={handleTableChange}
                        rowKey="msr_wplywy_id" 
                        rowClassName={(record) =>
                            `${blockedRows.some(item => item.msr_wplywy_msr_wplywy_id == record.msr_wplywy_id) ? "row-blocked" : ""} ${record.msr_wplywy_archived === 1 ? "archived" : ""}`
                        }
                    />
                </Spin>
            </div>

            <Modal 
                title="Wpływ zablokowany przez innego pracownika" 
                open={isModalOpen} 
                onCancel={handleModalClose} 
                footer={null}
            >
                {selectedRow &&<><p>Dany wpis jest już edytowany przez {blockedRows.find(x => x.msr_wplywy_msr_wplywy_id === selectedRow.msr_wplywy_id)?.user}.</p>
                <p>
                    Edycja rozpoczeła się 
                    {' '+
                        datetimeParser(
                        blockedRows.find(x => x.msr_wplywy_msr_wplywy_id === selectedRow.msr_wplywy_id)?.msr_blocked_wplywy_datetime, 
                        'YYYY-MM-DD HH:mm'
                        )
                    } 
                    
                     
                    {' ('+
                        (() => {
                        const blockedTime = new Date(parseInt(blockedRows.find(x => x.msr_wplywy_msr_wplywy_id == selectedRow.msr_wplywy_id)?.msr_blocked_wplywy_datetime) * 1000);
                        const currentTime = new Date();
                        const differenceInMs = currentTime - blockedTime;
                        const differenceInHours = differenceInMs / (1000 * 60 * 60);
                        
                        if (differenceInHours >= 1) {
                            return `${Math.round(differenceInHours)} GODZIN TEMU`;
                        } else {
                            const differenceInMinutes = differenceInMs / (1000 * 60);
                            return `${Math.round(differenceInMinutes)} MINUT TEMU`;
                        }
                        })()
                    +'). '}
                    </p>
                    <p>Przejęcie edycji może spowodować nadpisywanie zmian. Upewnij się, że poprzedni pracownik na pewno zakończył już prace.</p>
                    <Flex gap={10} justify="end">
                        <Button onClick={() => setIsModalOpen(false)}>Zamknij</Button>
                        <Button danger onClick={() => unBlockWplyw(selectedRow.msr_wplywy_id)}>Przejmij edycje</Button>
                    </Flex>
                    </>}
            </Modal>
        </>
    );
};

export default WplywyTable;
